<template>
  <div class="fc-content text-break">
    <div>
      <div v-if="eventData.type.type">
        <i v-if="eventData.type.type === 'presence'" class="fa fa-check pr-1"></i>
        <i v-else-if="eventData.type.type === 'vacation'" class="fa fa-plane pr-1"></i>
        <i v-else-if="eventData.type.type === 'absense'" class="fa fa-question pr-1"></i>
        <i v-else-if="eventData.type.type === 'sick'" class="fa fa-hospital-o pr-1"></i>
        <i v-else-if="eventData.type.type === 'holiday'" class="fa fa-beer pr-1 ml-2"></i>
        <span v-text="$t(`attendance.types.${eventData.type.type}`)"></span>
      </div>
      <div v-if="eventData.type.type === 'presence'">
        <i class="fa fa-clock-o pr-1"></i>
        {{ $options.filters.localTime(event.start, 'HH:mm')}} -
        {{ $options.filters.localTime(event.end, 'HH:mm')}}
      </div>
      <div v-if="eventData.type.type === 'holiday'" class="ml-3">
        <span class="is-bold" v-text="eventData.title" />
      </div>

    </div>
  </div>

</template>

<script>
const DEFAULT_COLOR = '#29c4a9'

export default {
  props: {
    view: {
      type: Object,
      required: true
    },
    event: {
      type: Object,
      required: true
    },
  },
  computed: {
    eventData: function () {
      return {
        ...this.event.extendedProps,
        title: this.event.title,
        start: this.event.start,
        end: this.event.end
      }
    },
    getEventTypeLabel: function () {
      if (!this.eventData.type) return null

      let label = this.$t(`leads.agenda.event_types.${this.eventData.type.name}`)

      if (this.eventData.type.slug && label !== this.eventData.type.slug) {
        label += ` (${this.eventData.type.slug})`
      }
      return label
    },
    popoverBackgroundColor: function () {
      return this.eventData && this.eventData.color ? this.eventData.color : DEFAULT_COLOR
    },
    popoverStyles: function () {
      return {
        color: 'white',
        'font-size': '0.8rem',
        'background-color': this.popoverBackgroundColor
      }
    }
  }
}
</script>

<style scoped>

</style>
